/**
 * @description 用户中心新接口 account 概念
 */
import axios from "utils/axios";
import type { CustomAxiosRequestConfig } from "@xt/xtbase";
import { FaSceneDictEnum } from "@/store/user";
const URL = "/uaapi/account/";

/**
 *
 * @description ================账户相关================
 */
//获取账户基本信息
export function get_accountInfo(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `info`);
}

//用户设备分页
export function get_clientDevice(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `device`, config);
}

// 账户设备全部删除
export function delete_allDevice(config?: CustomAxiosRequestConfig) {
  return axios.delete(URL + `device`, config);
}

// 删除一条账户设备
export function delete_device(id: number, config?: CustomAxiosRequestConfig) {
  return axios.delete(URL + `device/${id}`, config);
}
// 关闭帐户
export function delete_userClose(config?: CustomAxiosRequestConfig) {
  return axios.delete(URL + `fa/close-account`, config);
}

// 获取公钥-敏感场景避免明文传递
export function put_publicKey(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `public/authorize/public-key`, null, config);
}

// 国家地区列表-注册相关
export function get_regCountries(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `public/reg/countries`, config);
}

// 获取手机区号(未登录状态下)
export function get_faMobileCountries(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `public/fa/mobile/countries`, config);
}

// 国家地区列表（登录，认证相关）
export function get_authorizeCountries(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `public/authorize/countries`, config);
}

// 判断是否拦截注册
export function put_regIntercept(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `public/reg/intercept`, null, config);
}

// 获取验证码(注册)
export function put_regVerifyCode(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `public/reg/verify-code`, null, config);
}

// 注册
export function post_reg(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `public/reg`, null, config);
}

// 登录方式一: mfa快速登陆(注册接口下发)
export function post_authorizeRegMfa(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `public/authorize/reg-mfa`, null, config);
}

// 登录方式二: 通过fa凭证登录-前置校验
export function put_authorizeFaBeforeCheck(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `public/authorize/fa/before-check`, null, config);
}

// 登录方式二: 通过fa凭证登录
export function post_authorizeFa(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `public/authorize/fa`, null, config);
}

// 重置登录密码(忘记密码)-前置校验
export function put_faLoginPwdBeforeCheck(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `public/fa/login-pwd/before-check`, null, config);
}

//重置登录密码(忘记密码)
export function put_faLoginPwd(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `public/fa/login-pwd`, null, config);
}

/**
 * @description ================用户开通业务================
 */
// 获取用户已经开通的业务类型list
export function get_businessList(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `business/list`, config);
}

// 根据业务类型查询最新审核信息
export function get_businessAudit(code: string, config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `business/audit/${code}`, config);
}

// 用户申请开通业务
export function post_businesApply(config?: CustomAxiosRequestConfig<any, { bizId: string; businessCode: string }>) {
  return axios.post(URL + `business/apply`, null, config);
}

/**
 * @description ================2fa相关-安全验证================
 * faSceneDict字段如下枚举
 *绑定防钓鱼码: ANTI_FISHING_CODE__BIND; 更改防钓鱼码: ANTI_FISHING_CODE__MODIFY;
 * 创建API Key: API_KEY__CREATE; 更改API Key: API_KEY__MODIFY;
 * 绑定邮箱: EMAIL__BIND; 更改邮箱: EMAIL__MODIFY;
 * 绑定谷歌验证器: GA__BIND; 解绑谷歌验证器: GA__UNBIND;
 * 绑定手机: MOBILE__BIND; 更改手机: MOBILE__MODIFY;
 * 登录: LOGIN; 更改登录密码: LOGIN_PWD__MODIFY; 重置登录密码: LOGIN_PWD__RESET;
 */

// 获取验证项
export function put_verifyItem(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `fa/verify-item`, null, config);
}

// 验证-fa验证项(用于提交表单之前的验证码验证是否准确)
export function put_faVerify(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `public/fa/verify`, null, config);
}

// 获取验证码(2fa)
export function put_faVerifyCode(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `public/fa/verify-code`, null, config);
}

/**
 * @description ===============apiKey相关================
 * 新增、修改、删除、获取key list
 */
// 获取额apiKey 列表
export function get_apiKeyList(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `api-key/list`, config);
}

// 新增apiKey
interface ApiKeyDataProps extends ObjAny {
  faId: string;
  remarkName: string;
  roleScopes: string;
  whitelistIps: string;
}
export function post_addApiKey(config?: CustomAxiosRequestConfig<any, ApiKeyDataProps>) {
  return axios.post(URL + `api-key`, null, config);
}

// 修改apiKey
export function put_editApiKey(id: number, config?: CustomAxiosRequestConfig<any, ApiKeyDataProps>) {
  return axios.put(URL + `api-key/${id}`, null, config);
}

// 删除apiKey
export function del_apiKey(id: number, config?: CustomAxiosRequestConfig) {
  return axios.delete(URL + `api-key/${id}`, config);
}

/**
 * @description ================邮箱相关================
 */




// 绑定邮箱
export function post_bindEmail(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `fa/email`, null, config);
}
// 更改邮箱
export function put_modifyEmail(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `fa/email`, null, config);
}
// 获取新邮箱验证码
export function put_newEmailVerifyCode(config?: CustomAxiosRequestConfig<{ receiveAddr: string; faSceneDict: FaSceneDictEnum }>) {
  return axios.put(URL + `fa/email/verify-code`, null, config);
}

/**
 * @description ================手机相关================
 */

export interface NewMobileVerifyCodeProps {
  receiveAddr: string;
  faSceneDict: FaSceneDictEnum;
  msgChannelDict: "SMS" | "EMAIL" | "VOICE" | "LETTER" | "PUSH";
  countryCode: string;
}
export interface MobileDataProps {
  countryCode: string;
  faId: string;
  mobile: string;
  verifyCode: string;
}

export interface antiFishingCodeDataProps {
  faId: string;
  antiFishingCode: string;
}

export interface LoginPasswordDataProps {
  faId: string;
  newPassword: string;
  oldPassword: string;
  newPassword2: string;
}

export interface DataProps {
  countryCode: string;
  faId: string;
  phone: string;
  verifyCode: string;
}

//获取新手机验证码
export function put_newMobileVerifyCode(config?: CustomAxiosRequestConfig<NewMobileVerifyCodeProps>) {
  return axios.put(URL + `fa/mobile/verify-code`, null, config);
}

// 绑定手机
export function post_bindMobile(config?: CustomAxiosRequestConfig<any, MobileDataProps>) {
  return axios.post(URL + `fa/mobile`, null, config);
}

// 修改手机
export function put_modifyMobile(config?: CustomAxiosRequestConfig<any, MobileDataProps>) {
  return axios.put(URL + `fa/mobile`, null, config);
}

// 获取国家和区号（用于登录之后的绑定更改手机查询）
export function get_countryList(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `fa/mobile/countries`, config);
}


// 绑定防钓鱼码
export function post_bindFishingCode(config?: CustomAxiosRequestConfig<any, antiFishingCodeDataProps>) {
  return axios.post(URL + `fa/anti-fishing-code`, null, config);
}

// 修改防钓鱼码
export function put_modifyFishingCode(config?: CustomAxiosRequestConfig<any, antiFishingCodeDataProps>) {
  return axios.put(URL + `fa/anti-fishing-code`, null, config);
}


//  修改登录密码
export function put_modifyLoginPwd(config?: CustomAxiosRequestConfig<any, Omit<LoginPasswordDataProps, 'newPassword2'>>) {
  console.log(config, 'config');
  return axios.put(URL + `fa/login-pwd`, null, config);
}


// 新谷歌绑定
export function post_bindNewGoogleAuth(config?) {
  return axios.post(URL + `fa/google-auth`, null, config);
}

// 新谷歌解绑
export function delete_unBindNewGoogleAuth(config?) {
  return axios.delete(URL + `fa/google-auth`, config);
}

export function get_googleSecret(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `fa/google-auth/secret`, config);
}

// 获取用户的2fa配置项
export function get_fa(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `fa`, config);
}

// 用户的2fa配置项-开启
export function put_fa(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `fa`, null, config);
}

// 用户的2fa配置项-禁用
export function delete_fa(config?) {
  return axios.delete(URL + `fa`, config);
}

